import React, { useState } from "react";
import CoreFileUploader from "../../core/inputs/CoreFileUploader";

function MarutiDeedUpload() {
  const [file, setFile] = useState(null);

  const tool = "maruti-deed-processor";

  return (
    <>
      <div
        style={{
          height: "calc(100vh - 68px - 4px)",
          width: "calc(100% + 32px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "-8px",
          marginTop: "-30px",
        }}
      >
        <CoreFileUploader
          tool={tool}
          handleChange={(file) => {
            if (file) {
              setFile(file);
            }
          }}
          isMulti={false}
          customHelperText="Supported documents : Upload ZIP."
        />
      </div>
    </>
  );
}

export default MarutiDeedUpload;
